import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppService } from '../../services/app.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { StateService } from 'src/app/services/states.service';
@Component({
    selector: 'mess_confirmemail_dialog',
    templateUrl: 'mess_confirmemail_dialog.component.html',
    styleUrls: ['mess_confirmemail_dialog.component.scss']
})
export class MessConfirmEmail implements OnInit {
    objectKeys = Object.keys;
    message:string="";
    loading: boolean;
    constructor(
        private router: Router,
        private appService: AppService,
        public dialogRef: MatDialogRef<MessConfirmEmail>,
        private stateService: StateService,
        private cookies: CookieService,
        @Inject(MAT_DIALOG_DATA) public data: any //login + id
    ) {}

    ngOnInit() {
        this.loading = true;
        this.appService.connectAfterConfirm(this.data.login,this.data.id).subscribe((res)=>{
            
            if(res && res.result &&  res.result.connect === "OK" && res.result.user){
                res.result.user.identity.ID = res.result.user.ID;
                res.result.user.identity.email = res.result.user.connection.email;
                this.stateService.updateUser(res.result.user.identity);
                environment.tokenauth = res.result.token;
                environment.tokencsrf = "";
                this.cookies.set("Tokenauth", res.result.token);
            }else if(res && res.result && res.result.message){
                this.message = res.result.message;
            }else{
                this.message = "Une erreur est survenue lors de la confirmation de votre compte.";
            }
            this.loading = false;
        });
    }

    continue(){
        this.router.navigateByUrl("/dossier");
        this.dialogRef.close({});
    }
    dismissDialog(){
        this.dialogRef.close({});
    }

}